export default "__VITE_ASSET__Cv$eZi_D__"